import colors from '../foundation/colors';
import shadows from '../foundation/shadows';

const CloseButton = {
  baseStyle: {
    background: colors.primaryScale['50'],
    color: colors.primaryScale['600'],
    fontSize: '8px',
    borderRadius: '100px',
    height: '24px',
    width: '24px',
    mt: 1,
    _focus: { outline: 'none', boxShadow: shadows.focus },
    _hover: { background: colors.primaryScale['50'] }
  },
  sizes: { xs: { height: '24px', width: '24px', fontSize: '8px' } },
  defaultProps: { size: 'xs' }
};

export default CloseButton;
